import React from 'react'
// import { Link } from 'react-router-dom'
// import One from '../../assets/img/bg/an-img-02.png'
// import Two from '../../assets/img/features/signature.png'
import Abouttwo from '../../assets/img/features/nuestrosvalores.jpg'
// import Aboutthree from '../../assets/img/features/about_img_02.jpg'


function Safe() {

  return (
    <>
         <section className="about-area about-p pt-120 pb-120 p-relative fix">
                {/* <div className="animations-02"><img src={One} alt="contact-bg-an-02"/></div> */}
                <div className="container">
                    <div className="row justify-content-center align-items-center">
					    <div className="col-lg-6 col-md-12 col-sm-12">
                            <div className="about-content s-about-content  wow fadeInRight  animated pl-30" data-animation="fadeInRight" data-delay=".4s">
                                <div className="about-title second-title pb-25">  
                                    <h5>Nuestros</h5>
                                    <h2>Valores</h2>                                   
                                </div>
                                   {/* <p>Morbi tortor urna, placerat vel arcu quis, fringilla egestas neque. Morbi sit amet porta erat, quis rutrum risus. Vivamus et gravida nibh, quis posuere felis. In commodo mi lectus, Integer ligula lorem, finibus vitae lorem vitae tincidunt dolor consequat quis.</p> */}
                                    <p>En El Hotel La Finca nos comprometemos a brindar una experiencia de hospitalidad cálida y personalizada, celebrando la autenticidad de nuestra cultura y el arte de la región. Buscamos la excelencia en cada detalle, fomentamos la inclusión y la diversidad, y apostamos por la innovación para mejorar continuamente la experiencia de nuestros huéspedes.</p>
                                    <div className="about-content3 mt-30">
                                    <div className="row justify-content-center align-items-center">
                                    <div className="col-md-12">
                                        <ul className="green mb-30">                                              
                                            <li> Hospitalidad: Ofrecemos un servicio cálido y personalizado para que cada huésped
                                            se sienta bienvenido.</li>
                                            <li>Autenticidad: Celebramos y promovemos la cultura, el arte y la historia de la región.</li>     
                                            <li> Excelencia: Nos comprometemos a ofrecer un servicio de alta calidad y cuidado en
                                            cada detalle.</li>
                                            <li>Inclusión: Fomentamos un ambiente donde todos somos bienvenidos, respetados y
                                            valorados, sin importar su origen, condición o identidad.</li>
                                            <li>Innovación: Buscamos nuevas formas de mejorar la experiencia de nuestros
                                            huéspedes y visitantes.</li>
                                        </ul>
                                    </div>
                                    {/* <div className="col-md-6">
                                        <div className="slider-btn">                                          
                                            <Link to="/about" className="btn ss-btn smoth-scroll">Discover More</Link>				
                                        </div>
                                    </div> */}
                                    <div className="col-md-6 text-right">
                                        {/* <div className="signature">
                                            <img src={Two} alt="img"/>                                             
                                        </div> */}
                                    </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-6 col-md-12 col-sm-12">
                            <div className="s-about-img p-relative  wow fadeInLeft animated" data-animation="fadeInLeft" data-delay=".4s">
                                <img src={Abouttwo} alt="img"/>   
                                {/* <div className="about-icon">
                                    <img src={Aboutthree} alt="img"/>   
                                </div> */}
                            </div>
                        </div>
                    </div>
                </div>
            </section>
    </>
  )
}

export default Safe